import {useCallback, useEffect, useRef, useState} from 'react';
import copy from 'copy-to-clipboard';
import translate from '@/utils/translate';

const CLEAR_AFTER_MS = 2000;

/**
 * Confirms inline rather than through a toast: CWA's flash-message service is never
 * mounted, so `raiseFlashMessage` would be silent.
 */
export default function useCopyToClipboard() {
  const [notification, setNotification] = useState<string | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    []
  );

  const copyText = useCallback((text: string) => {
    const succeeded = copy(text);
    // Value-agnostic: callers copy tracking URLs and discount codes alike.
    setNotification(
      succeeded
        ? translate('Copied to clipboard.')
        : translate('Could not copy. Does your browser support the clipboard?')
    );
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(
      () => setNotification(null),
      CLEAR_AFTER_MS
    );
    return succeeded;
  }, []);

  return {notification, copyText};
}
